import { paymentApi } from '@/app/providers/api';

interface UpdateUserResponse {
  success: string;
  data: {
    password: string;
  };
}

interface UpdateUserPayload {
  email?: string;
  userId?: string;
  fullName?: string;
  phoneNumber?: string;
  password?: string;
  formData?: FormData;
}

interface UpdatePasswordPayload {
  password?: string;
  userId?: string;
}

const updateUser = paymentApi.injectEndpoints({
  endpoints: (builder) => ({
    updateUser: builder.mutation<UpdateUserResponse, UpdateUserPayload>({
      query: (user) => ({
        url: '/redeem/user-update',
        method: 'POST',
        body: {
          email: user.email,
          userId: user.userId,
          fullName: user.fullName,
        },
      }),
    }),
    updatePassword: builder.mutation<unknown, UpdatePasswordPayload>({
      query: (user) => ({
        url: '/redeem/password-update',
        method: 'POST',
        body: {
          userId: user.userId,
          password: user.password,
        },
      }),
    }),
  }),
});

export const { useUpdateUserMutation, useUpdatePasswordMutation } = updateUser;
